<template>
  <div class="story-downloader-page">
    <HeadNav page="instasave" />
    <!-- <Breadcrumb routeName="story-downloader" /> -->
    
    <!-- Hero Section -->
    <HeroSection 
      :title="heroTitle"
      :subtitle="heroSubtitle"
      :inputPlaceholder="inputPlaceholder"
      :activeTab="activeTab"
      @tab-change="switchTab"
      @download-content="downloadContent"
      @go-to-download="goToDownload"
      @join-telegram="joinTelegramChannel"
    />

    <div class="home-wrapper">
      <!-- How to Section -->
      <HowToSection 
      :title="howToTitle"
      :description="howToDescription"
      :steps="howToSteps"
    />

    <!-- App Recommendation Section -->
    <AppRecommendationSection 
      :title="appRecommendationTitle"
      :description="appRecommendationDescription"
      :buttonText="appRecommendationButtonText"
      :imageSrc="appRecommendationImageSrc"
      :imageAlt="appRecommendationImageAlt"
      :showImage="true"
      @go-to-download="goToDownload"
    />

    <h2 class="left-title">Why Choose Our Instagram Story Downloader?</h2>

    <!-- Features Section -->
    <FeaturesGrid :features="features" />

    <!-- FAQ Section -->
    <section class="faq-section">
      <div class="container">
        <h2 class="section-title">FAQs</h2>
        <div class="faq-list">
          <div 
            v-for="(faq, index) in faqs" 
            :key="index" 
            class="faq-item"
            :class="{ 'expanded': expandedFaqs.includes(index) }"
          >
            <div class="faq-question" @click="toggleFaq(index)">
              <div>{{ faq.question }}</div>
              <span class="faq-icon">{{ expandedFaqs.includes(index) ? '−' : '+' }}</span>
            </div>
            <div class="faq-answer" v-if="expandedFaqs.includes(index)">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    </div>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import HeroSection from '@/components/HeroSection.vue'
import AppRecommendationSection from '@/components/AppRecommendationSection.vue'
import HowToSection from '@/components/HowToSection.vue'
import FeaturesGrid from '@/components/FeaturesGrid.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'StoryDownloader',
  components: {
    HeadNav,
    Breadcrumb,
    HeroSection,
    AppRecommendationSection,
    HowToSection,
    FeaturesGrid,
    Footer
  },
  head() {
    return {
      title: 'Instagram Story Downloader - Stories Saver',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Easily download your Instagram stories with Story Saver – no sign-up required. Our Instagram Story Downloader lets you save stories in just one click.'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'instagram story downloader, instagram story saver, download instagram stories, save instagram stories'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://instasaves.io/story-downloader/'
        }
      ]
    }
  },
  data() {
    return {
      pageName: 'story-downloader',
      instagramLink: '',
      expandedFaqs: [],
      activeTab: 'story',
      heroTitle: 'Instagram Story Downloader',
      heroSubtitle: 'Just paste the Instagram link and click the download button to save your stories instantly.',
      inputPlaceholder: 'Paste Instagram story link here',
      howToTitle: 'How to Download Story from Instagram',
      howToDescription: 'You can download Instagram stories using two simple methods:',
      howToSteps: [
        {
          title: 'Download Instagram Stories Online',
          items: [
            {
              title: 'Step 1: Copy the Instagram Story Link',
              content: [
                'Open Instagram (app or web) and find the video you need to download.',
                'Tap the three-dot icon (or Share) on a video.',
                'Choose Copy link.'
              ]
            },
            {
              title: 'Step 2: Paste the Link',
              content: [
                'Return here and paste the link into the download box of our site.'
              ]
            },
            {
              title: 'Step 3: Download Story',
              content: [
                'It will load the IG content. Then, hit the Download button.',
                'It will be saved on your phone or PC.'
              ]
            }
          ]
        },
        {
          title: 'Instagram Story Saver App',
          items: [
            {
              content: [
                'Download the <a href="https://instasaves.io/instagram-apk-downlad/" target="_blank">InstaSave APK</a> from our trusted source.',
                'Install the app on your device.',
                'Open the app – no extra setup required.',
                'Paste the Instagram story, reel, or post link inside the app.',
                'Click Download to save the content instantly in high quality.'
              ]
            }
          ]
        }
      ],
      appRecommendationTitle: 'Download InstaSave APK for Andriod',
      appRecommendationDescription: 'Download our <a href="https://instasaves.io/instagram-apk-downlad/" class="jump-url" target="_blank">InstaSave APK</a> and start using it directly within the app, Our app delivers fast, high-quality downloads without watermarks, making it the perfect tool to save Instagram stories effortlessly.',
      appRecommendationButtonText: 'Install Now',
      appRecommendationImageSrc: require('@/assets/story/story-1.webp'),
      appRecommendationImageAlt: 'InstaSave App',
      features: [
        {
          title: "1080p HD Downloads",
          description: "Save Instagram stories, reels, and posts in full high-definition for the best quality.",
          imageSrc: require('@/assets/story/story-2.webp'),
          imageAlt: "1080p HD Downloads"
        },
        {
          title: "Works in India",
          description: "Our Instagram story downloader is optimized for users in India and supports all local Instagram accounts.",
          imageSrc: require('@/assets/story/story-3.webp'),
          imageAlt: "Works in India"
        },
        {
          title: "Safe & Secure",
          description: "Download content without logging in or compromising your privacy—completely safe to use.",
          imageSrc: require('@/assets/story/story-4.webp'),
          imageAlt: "Safe & Secure"
        },
        {
          title: "Free to Use",
          description: "Enjoy all features without any cost, no hidden fees or subscriptions.",
          imageSrc: require('@/assets/story/story-5.webp'),
          imageAlt: "Free to Use"
        }
      ],
      faqs: [
        {
          question: "Do I need to sign in to Instagram to download stories?",
          answer: "No, you can download public Instagram stories, reels, and posts without signing in."
        },
        {
          question: "Can I download stories in high quality?",
          answer: "Absolutely! The app supports 1080p HD downloads for photos, videos, reels, and IGTV content."
        },
        {
          question: "Does it work on Android and iOS?",
          answer: "The APK app is for Android only, but our online tool works on both Android and iOS devices."
        },
        {
          question: "Is it safe to use Instagram Story Download?",
          answer: "Yes. Our app and online tool are secure and do not collect your Instagram login credentials."
        },
        {
          question: "Can I download content from private Instagram accounts?",
          answer: "No, downloads are only available from public profiles or accounts you follow."
        },
        {
          question: "How fast are the downloads?",
          answer: "Downloads are instant—just paste the link and click the download button to save stories, reels, or posts in one click."
        }
      ]
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab
      console.log('Switching to tab:', tab)
    },
    downloadContent() {
      // Handle download logic
      console.log('Download content:', this.instagramLink)
    },
    goToDownload() {
      this.$router.push('/instagram-apk-downlad/')
    },
    joinTelegramChannel() {
      window.open('https://t.me/+M75kow80SlQ1MjZl', '_blank')
    },
    toggleFaq(index) {
      const expandedIndex = this.expandedFaqs.indexOf(index)
      if (expandedIndex > -1) {
        this.expandedFaqs.splice(expandedIndex, 1)
      } else {
        this.expandedFaqs.push(index)
      }
    }
  }
}
</script>

<style scoped>
.home-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 1rem;
}

.left-title{
    width:1200px;
    margin: 0 auto;
    padding-left: 20px;
    padding-top: 80px;
    text-align: center;
    @media (max-width: 768px) {
    width: 100%;
    padding-left: 0;
  }
}

.story-downloader-page {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.faq-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.faq-question {
  padding: 25px 30px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transition: all 0.3s ease;
}

.faq-question:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
}

.faq-question h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
}

.faq-icon {
  font-size: 1.5rem;
  font-weight: bold;
  color: #667eea;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.faq-item.expanded .faq-icon {
  background: #667eea;
  color: white;
  transform: rotate(180deg);
}

.faq-answer {
  padding: 0 30px 25px;
  background: white;
}

.faq-answer p {
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
    margin-bottom: 30px;
  }
  
  .faq-question {
    padding: 20px;
  }
  
  .faq-question h3 {
    font-size: 1.1rem;
  }
  
  .faq-answer {
    padding: 0 20px 20px;
  }
  
  .faq-icon {
    width: 25px;
    height: 25px;
    font-size: 1.2rem;
  }
}
</style>
